import { useContext, useEffect } from 'react'
import { ServerSeoContext } from '@/lib/seo'

/**
 * Sets `document.title` for as long as the calling page is mounted.
 * Pass `undefined`/`null`/`''` while the title isn't ready yet (e.g. data
 * still loading) — the browser tab keeps its previous title until a real
 * value is supplied. The next page sets its own title on mount, so there's
 * no need to restore a default on unmount.
 */
export function usePageTitle(title: string | null | undefined): void {
  const serverSeo = useContext(ServerSeoContext)
  useEffect(() => {
    if (!title || serverSeo) return
    document.title = title
  }, [title, serverSeo])
}
